import {toNumber} from "lodash";

export default {
    updateLocationSelected(value) {
        this.locationSelected = toNumber(value)
    },
    addTrial(id) {
        this.query.trials.push(id)
        this.trialsSelected.push(id)
    },
    removeTrial(id) {
        this.query.trials.splice(id, 1)
        this.trialsSelected.splice(id, 1)
    },
    removeTrialByValue(value) {
        this.query.trials = this.trialsSelected.filter(item => item !== value)
        this.trialsSelected = this.trialsSelected.filter(item => item !== value)
    }
}
